import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'LXI';
const BASE_URL = 'https://wearelxi.com';
const DEFAULT_DESCRIPTION = 'LXI Founders Edition — La armadura del gladiador moderno. Ropa premium para quienes eligieron enfrentar su arena.';
const DEFAULT_IMAGE = `${BASE_URL}/images/og-hero.jpg`;

const SEO = ({ title, description, path, image, type = 'website', price }) => {
  const fullTitle = title ? `${title} | LXI` : 'LXI — Founders Edition | wearelxi.com';
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonical = path ? `${BASE_URL}${path}` : BASE_URL;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />

      {price && <meta property="product:price:amount" content={String(price)} />}
      {price && <meta property="product:price:currency" content="USD" />}
    </Helmet>
  );
};

export default SEO;
